<template>
  <div
    class="flex flex-wrap gap-2"
    :class="pdpOrPlp === 'pdp' ? 'items-end' : 'flex-col'"
  >
    <div
      v-for="tag in tagsToShow"
      :key="tag?.name"
      class="flex h-8 w-fit items-center gap-1 border px-4 py-0.5 text-sm uppercase mobile:h-6 mobile:px-2 mobile:py-0 mobile:text-xs"
      :style="{
        backgroundColor: tag?.backgroundColor,
        color: tag?.fontColor,
        borderColor: tag?.borderColor,
        flexDirection: tag?.iconPosition === 'right' ? 'row-reverse' : 'row',
        visibility: showTag(tag) ? 'visible': 'hidden',
      }"
    >
      <NuxtImg
        v-if="tag?.svgIcon && tag?.svgIcon !== '' && tag?.iconPosition !== 'none'"
        :src="tag?.svgIcon"
        class="py-1"
        :width="$device.isMobile ? 16 : 24"
        :height="$device.isMobile ? 16 : 24"
        fit="inside"
      />
      {{ tag?.displayName }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTagsLoader } from '~/composables/custom/useTagLoader/useTagLoader';

interface Props {
  marketingTags: string[];
  pdpOrPlp: 'pdp' | 'plp';
}

interface Tag {
  name: string;
  displayName: string;
  backgroundColor: string;
  fontColor: string;
  borderColor: string;
  svgIcon: string;
  iconPosition: 'left' | 'right' | 'none';
  showInPdp: boolean;
  showInPlp: boolean;
  tagDisabled: boolean;
  priority: number;
}

const { tags } = useTagsLoader();

const props = defineProps<Props>();

const showTag = (tag: Tag) => {
  if (tag.tagDisabled) {
    return false;
  }

  return (
    (tag.showInPdp && props.pdpOrPlp === 'pdp')
    || (tag.showInPlp && props.pdpOrPlp === 'plp')
  );
};

const comparePriority = (tagA: Tag, tagB: Tag) => {
  if (tagA.priority > tagB.priority) {
    return -1;
  }

  if (tagA.priority < tagB.priority) {
    return 1;
  }

  return 0;
};

const tagsToShow = computed(() => tags.value?.filter(tag => props.marketingTags.includes(tag.displayName)).sort(comparePriority) ?? []);
</script>
